/*
 * This unpublished material is proprietary to Vaticle.
 * All rights reserved. The methods and
 * techniques described herein are considered trade secrets
 * and/or confidential. Reproduction or distribution, in whole
 * or in part, is forbidden except by express written permission
 * of Vaticle.
 */

import { Pipe, PipeTransform } from "@angular/core";
import { storageSizeToString } from "../../concept/cluster";

@Pipe({
    name: "storageSize",
    standalone: true,
})
export class StorageSizePipe implements PipeTransform {
    transform(sizeGB: number): string {
        return storageSizeToString(sizeGB);
    }
}
